export const Value = ({type, quantity}) => {
    return <li>
        <p>{type}: {quantity}</p>
    </li>
}